module.exports = __webpack_public_path__ + "static/media/txnFailed.818c47fa.svg";